// 会场管理模块状态 - 独立于其他模块
// 初始化时从本地缓存获取数据，没有缓存则清除（返回初始空状态）
const getInitialState = () => {
  const cacheKey = 'venueManage'
  const cached = localStorage.getItem(cacheKey)
  if (cached) {
    try {
      const parsed = JSON.parse(cached)
      return parsed
    } catch (e) {
      // 缓存无效时清除
      localStorage.removeItem(cacheKey)
    }
  }
  // 无缓存或清除后返回初始状态
  return {
    /** 是否已登录 */
    isLogin: undefined,
    /** 登录信息 */
    loginInfo: {},
    /** token等凭证信息 */
    token: ''
  }
}

export default getInitialState()
